import { useTranslation } from 'react-i18next';

interface LoginSignUpLinkProps {
  url: string;
}

const LoginSignUpLink = ({ url }: LoginSignUpLinkProps) => {
  // TODO whitelabelling
  const { t } = useTranslation();

  if (!url) {
    return null;
  }

  return (
    <a className="action-link" data-testid="signup-link" href={url}>
      {t('pageLogin.notSignedUp')}
    </a>
  );
};

export default LoginSignUpLink;
